'use es6';

import { ActionTypes } from '../constants/AppConstants';
import produce from 'immer';
var defaultState = {
  email: ''
};
var Contact = produce(function (draftState, action) {
  switch (action.type) {
    case ActionTypes.STORE_CONTACT:
      {
        if (action.payload && action.payload.contactEmail) {
          draftState.email = action.payload.contactEmail;
        }

        return draftState;
      }

    default:
      return draftState;
  }
}, defaultState);
export default Contact;